import { Button, styled } from "@mui/material";

export const StyledLinkButton = styled(Button)`
  padding: 0;
  font-size: inherit;
  justify-content: left;
  vertical-align: baseline;
  line-height: initial;
  min-width: auto;

  &:hover,
  &:focus {
    background-color: transparent;
    text-decoration: underline;
  }
`;
